(function () {
  'use strict';

  function track(name, properties) {
    if (window.HaroHKAnalytics) window.HaroHKAnalytics.track(name, properties || {});
  }

  function safeText(value) {
    return String(value || '').trim().toLowerCase();
  }

  function parseHours(value) {
    if (!value) return {};
    try {
      var parsed = JSON.parse(value);
      if (typeof parsed === 'string') parsed = JSON.parse(parsed);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function parseClock(value) {
    var match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(String(value || ''));
    if (!match) return null;
    return Number(match[1]) * 60 + Number(match[2]);
  }

  function hongKongClock(timestamp) {
    var days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    var date = timestamp instanceof Date ? timestamp : new Date(timestamp);
    if (Number.isNaN(date.getTime())) return null;
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Hong_Kong',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    var day = String(values.weekday || '').slice(0, 3).toLowerCase();
    var dayIndex = days.indexOf(day);
    var hour = Number(values.hour);
    var minute = Number(values.minute);
    if (dayIndex < 0 || !Number.isInteger(hour) || !Number.isInteger(minute)) return null;
    return { day: day, dayIndex: dayIndex, minutes: hour * 60 + minute };
  }

  function validPeriod(period) {
    if (!period || typeof period !== 'object') return null;
    var open = parseClock(period.open);
    var close = parseClock(period.close);
    if (open === null || close === null || open === close) return null;
    return { open: open, close: close, overnight: close < open };
  }

  function isOpenAt(hoursValue, timestamp) {
    var days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    var schedule = parseHours(hoursValue);
    var clock = hongKongClock(timestamp);
    if (!clock) return false;

    var currentPeriods = Array.isArray(schedule[clock.day]) ? schedule[clock.day] : [];
    var openFromCurrentDay = currentPeriods.some(function (period) {
      var parsed = validPeriod(period);
      if (!parsed) return false;
      if (parsed.overnight) return clock.minutes >= parsed.open;
      return clock.minutes >= parsed.open && clock.minutes < parsed.close;
    });
    if (openFromCurrentDay) return true;

    var previousDay = days[(clock.dayIndex + 6) % 7];
    var previousPeriods = Array.isArray(schedule[previousDay]) ? schedule[previousDay] : [];
    return previousPeriods.some(function (period) {
      var parsed = validPeriod(period);
      return Boolean(parsed && parsed.overnight && clock.minutes < parsed.close);
    });
  }

  function isOpenNow(card) {
    return isOpenAt(card.dataset.hours, new Date());
  }

  function confirmedRecently(card) {
    if (!card.dataset.confirmedAt) return false;
    var confirmed = new Date(card.dataset.confirmedAt + 'T00:00:00');
    if (Number.isNaN(confirmed.getTime())) return false;
    var ageDays = (Date.now() - confirmed.getTime()) / 86400000;
    return ageDays >= 0 && ageDays <= 30;
  }

  function distanceKm(lat1, lon1, lat2, lon2) {
    var toRad = function (value) { return value * Math.PI / 180; };
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function parseCoordinate(value) {
    var normalized = String(value === undefined || value === null ? '' : value).trim();
    if (normalized === '') return null;
    var coordinate = Number(normalized);
    return Number.isFinite(coordinate) ? coordinate : null;
  }

  function locationDistance(card, userPosition) {
    var latitude = parseCoordinate(card && card.dataset && card.dataset.latitude);
    var longitude = parseCoordinate(card && card.dataset && card.dataset.longitude);
    if (latitude === null || longitude === null) return Number.POSITIVE_INFINITY;
    return distanceKm(userPosition.latitude, userPosition.longitude, latitude, longitude);
  }

  function compareLocationDistance(left, right, userPosition) {
    return locationDistance(left, userPosition) - locationDistance(right, userPosition);
  }

  var previewDirectorySources = {
    governmentOptometry: {
      label: 'Hong Kong Government community optometry provider list',
      url: 'https://www.primaryhealthcare.gov.hk/cdcc/resources/cdcc_opto_list.pdf'
    },
    hospitalAuthority: {
      label: 'Hospital Authority private ophthalmologist directory',
      url: 'https://www4.ha.org.hk/ppp/en/ppp-programmes/csp/list-of-psp'
    },
    hongKongEyeHospital: {
      label: 'Hong Kong Eye Hospital',
      url: 'https://www3.ha.org.hk/HKEH/eng/main/contact-us.htm'
    },
    queenMaryHospital: {
      label: 'Queen Mary Hospital Department of Ophthalmology',
      url: 'https://www8.ha.org.hk/qmh/services/clinical_department/department/oph/oph.aspx'
    },
    cuhkEyeCentre: {
      label: 'CUHK Medical Centre Eye Centre',
      url: 'https://www.cuhkmc.hk/hospital-service/centres/eye-centre'
    }
  };

  var previewDirectoryLocations = [
    { id: 'HK-PUBLIC-01', name: 'The Optometry (OPT) Centre', type: 'optometrist', district: 'Causeway Bay', mtr: 'Causeway Bay', latitude: 22.2802, longitude: 114.1849, address: 'Unit A, 11/F, Hang Seng Causeway Bay Building, 28 Yee Wo Street, Causeway Bay, Hong Kong', phone: '3910 8568', source: 'governmentOptometry' },
    { id: 'HK-PUBLIC-02', name: 'New Town Eye Care — Wong Tai Sin', type: 'optometrist', district: 'Wong Tai Sin', mtr: 'Wong Tai Sin', latitude: 22.3420, longitude: 114.1937, address: 'N301-302, 3/F, Temple Mall North, 136 Lung Cheung Road, Wong Tai Sin, Kowloon', phone: '2153 3992', source: 'governmentOptometry' },
    { id: 'HK-PUBLIC-03', name: 'New Town Eye Care — V Walk', type: 'optometrist', district: 'Sham Shui Po', mtr: 'Nam Cheong', latitude: 22.3268, longitude: 114.1539, address: 'Shop G-3, G/F, V Walk, 28 Sham Mong Road, Sham Shui Po, Kowloon', phone: '2617 8121', source: 'governmentOptometry' },
    { id: 'HK-PUBLIC-04', name: 'New Town Eye Care — Tsim Sha Tsui', type: 'optometrist', district: 'Tsim Sha Tsui', mtr: 'Tsim Sha Tsui', latitude: 22.2969, longitude: 114.1722, address: 'Units 801-803, 8/F, 26 Nathan Road, Tsim Sha Tsui, Kowloon', phone: '2368 8032', source: 'governmentOptometry' },
    { id: 'HK-PUBLIC-05', name: 'New Town Eye Care — Tuen Mun', type: 'optometrist', district: 'Tuen Mun', mtr: 'Tuen Mun', latitude: 22.3913, longitude: 113.9771, address: 'Unit 307, Level 3, New Town Mansion, 2 Tuen Lee Street, Tuen Mun, New Territories', phone: '2441 7603', source: 'governmentOptometry' },
    { id: 'HK-PUBLIC-06', name: 'New Town Eye Care — Yuen Long', type: 'optometrist', district: 'Yuen Long', mtr: 'Yuen Long', latitude: 22.4456, longitude: 114.0222, address: 'Units 221-224, 2/F, Kolour Yuen Long, 1 Kau Yuk Road, Yuen Long, New Territories', phone: '2341 9500', source: 'governmentOptometry' },
    { id: 'HK-PUBLIC-07', name: 'New Town Eye Care — Fanling', type: 'optometrist', district: 'Fanling', mtr: 'Fanling', latitude: 22.4920, longitude: 114.1393, address: 'Unit 102B, G/F, Fanling Centre, 33 San Wan Road, Fanling, New Territories', phone: '2669 9386', source: 'governmentOptometry' },
    { id: 'HK-PUBLIC-08', name: 'Hong Kong Eye Hospital', type: 'clinic', district: 'Kowloon City', mtr: 'Mong Kok East', latitude: 22.3231, longitude: 114.1836, address: '147K Argyle Street, Kowloon, Hong Kong', phone: '2762 3007', source: 'hongKongEyeHospital' },
    { id: 'HK-PUBLIC-09', name: 'Queen Mary Hospital — Department of Ophthalmology', type: 'clinic', district: 'Pok Fu Lam', mtr: 'HKU, then local transit', latitude: 22.2706, longitude: 114.1312, address: '102 Pok Fu Lam Road, Hong Kong', phone: '2255 3838', source: 'queenMaryHospital' },
    { id: 'HK-PUBLIC-10', name: 'CUHK Medical Centre Eye Centre', type: 'clinic', district: 'Sha Tin', mtr: 'University', latitude: 22.4140, longitude: 114.2100, address: '9 Chak Cheung Street, Sha Tin, New Territories', phone: '3946 6888', source: 'cuhkEyeCentre' },
    { id: 'HK-PUBLIC-11', name: 'Dr. Baig Nafees Begum — Admiralty', type: 'ophthalmologist', district: 'Admiralty', mtr: 'Admiralty', latitude: 22.2774, longitude: 114.1654, address: 'Level 21, One Pacific Place, 88 Queensway, Hong Kong', phone: '2855 6700', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-12', name: 'Dr. Chan Chia Chieh, Orlando', type: 'ophthalmologist', district: 'Central', mtr: 'Central', latitude: 22.2815, longitude: 114.1578, address: 'Room 2601-04 & 06-08, 26/F, 9 Queen’s Road Central, Hong Kong', phone: '2381 3001', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-13', name: 'Dr. Chan Hoi Yee, Catherine', type: 'ophthalmologist', district: 'Central', mtr: 'Central', latitude: 22.2822, longitude: 114.1575, address: 'Unit 1101, 11/F, Hing Wai Building, 36 Queen’s Road Central, Hong Kong', phone: '3955 8113', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-14', name: 'Dr. Chan Wai Lok — Central Building', type: 'ophthalmologist', district: 'Central', mtr: 'Central', latitude: 22.2815, longitude: 114.1560, address: 'Suite 1515, 15/F, Central Building, 1-3 Pedder Street, Central, Hong Kong', phone: '3997 3566', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-15', name: 'Dr. Chau Kwok On, Gordon', type: 'ophthalmologist', district: 'Central', mtr: 'Central', latitude: 22.2813, longitude: 114.1590, address: 'Room 1420, 14/F, Prince’s Building, 10 Chater Road, Central, Hong Kong', phone: '2501 0909', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-16', name: 'Dr. Cheng Pak Man, George', type: 'ophthalmologist', district: 'Central', mtr: 'Central', latitude: 22.2822, longitude: 114.1557, address: 'Room 1009, 10/F, Melbourne Plaza, 33 Queen’s Road Central, Hong Kong', phone: '2868 1186', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-17', name: 'Dr. Baig Nafees Begum — Happy Valley', type: 'ophthalmologist', district: 'Happy Valley', mtr: 'Causeway Bay, then local transit', latitude: 22.2698, longitude: 114.1842, address: '4/F, Li Shu Fan Block, 2 Village Road, Happy Valley, Hong Kong', phone: '2835 8890', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-18', name: 'Dr. Choy Nga Kwan — Causeway Bay', type: 'ophthalmologist', district: 'Causeway Bay', mtr: 'Causeway Bay', latitude: 22.2798, longitude: 114.1839, address: '3/F, Plaza 2000, 2-4 Russell Street, Causeway Bay, Hong Kong', phone: '3158 8528', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-19', name: 'Dr. Tse Wai Ip', type: 'ophthalmologist', district: 'Causeway Bay', mtr: 'Causeway Bay', latitude: 22.2810, longitude: 114.1820, address: '7/F, Tower 535, 535 Jaffe Road, Causeway Bay, Hong Kong', phone: '2152 8521', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-20', name: 'Dr. Chan Cheuk Ki', type: 'ophthalmologist', district: 'Mong Kok', mtr: 'Mong Kok', latitude: 22.3193, longitude: 114.1694, address: 'Room 1119, 11/F, Phase I, Argyle Centre, 688 Nathan Road, Mong Kok, Kowloon', phone: '2309 2308', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-21', name: 'Dr. Chan Chi Wang — Tsim Sha Tsui', type: 'ophthalmologist', district: 'Tsim Sha Tsui', mtr: 'Tsim Sha Tsui', latitude: 22.3017, longitude: 114.1722, address: 'Unit 1802, 18/F, Mira Place Tower A, 132 Nathan Road, Tsim Sha Tsui, Kowloon', phone: '2986 1000', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-22', name: 'Dr. Chan Woon Ming — Prince Edward', type: 'ophthalmologist', district: 'Prince Edward', mtr: 'Prince Edward', latitude: 22.3242, longitude: 114.1690, address: '327 Prince Edward Road, Kowloon, Hong Kong', phone: '2200 3240', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-23', name: 'Dr. Chiu Yee Hang, Thomas', type: 'ophthalmologist', district: 'Tsim Sha Tsui', mtr: 'Tsim Sha Tsui', latitude: 22.2966, longitude: 114.1722, address: 'Room 2201, 22/F, 26 Nathan Road, Tsim Sha Tsui, Kowloon', phone: '2648 2010', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-24', name: 'Dr. Chow Man Ming', type: 'ophthalmologist', district: 'Tsim Sha Tsui', mtr: 'Tsim Sha Tsui', latitude: 22.2997, longitude: 114.1732, address: 'Room 1207, 12/F, Albion Plaza, 2-6 Granville Road, Tsim Sha Tsui, Kowloon', phone: '2388 2993', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-25', name: 'Dr. Cheung Janice', type: 'ophthalmologist', district: 'Tsim Sha Tsui', mtr: 'Tsim Sha Tsui', latitude: 22.2967, longitude: 114.1708, address: '9/F, Kaiseng Commercial Centre, 4-6 Hankow Road, Tsim Sha Tsui, Kowloon', phone: '2628 1111', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-26', name: 'Dr. Fan Ching Yim Michelle', type: 'ophthalmologist', district: 'Tsim Sha Tsui', mtr: 'Tsim Sha Tsui', latitude: 22.2976, longitude: 114.1698, address: 'Units 1409B-1410, 14/F, Hong Kong Pacific Centre, 28 Hankow Road, Tsim Sha Tsui, Kowloon', phone: '2608 1008', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-27', name: 'Dr. Chan Chi Wang — Tseung Kwan O', type: 'ophthalmologist', district: 'Tseung Kwan O', mtr: 'Po Lam', latitude: 22.3155, longitude: 114.2550, address: 'Shops 101-102, Level 1, MCP Discovery, 8 Mau Yip Road, Tseung Kwan O, New Territories', phone: '2721 0100', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-28', name: 'Dr. Chan Wai Lok — Metro City', type: 'ophthalmologist', district: 'Tseung Kwan O', mtr: 'Po Lam', latitude: 22.3225, longitude: 114.2570, address: 'Shops G55-56, G/F, Metro City Phase I, 1 Wan Hang Road, Tseung Kwan O, New Territories', phone: '3997 3566', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-29', name: 'Dr. Choy Nga Kwan — Nan Fung Plaza', type: 'ophthalmologist', district: 'Tseung Kwan O', mtr: 'Hang Hau', latitude: 22.3085, longitude: 114.2600, address: 'Unit A-48, G/F, Nan Fung Plaza, 8 Pui Shing Road, Tseung Kwan O, New Territories', phone: '2628 1111', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-30', name: 'Dr. Chan Chi Wang — Union Hospital', type: 'ophthalmologist', district: 'Tai Wai', mtr: 'Tai Wai', latitude: 22.3687, longitude: 114.1785, address: '2/F, Medical Centre, Union Hospital, 18 Fu Kin Street, Tai Wai, New Territories', phone: '2608 3368', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-31', name: 'Dr. Chan Wai Lok — Sha Tin', type: 'ophthalmologist', district: 'Sha Tin', mtr: 'Sha Tin', latitude: 22.3825, longitude: 114.1890, address: 'Shops 1C-1F & 5A, 2/F, Wai Wah Centre, 11-17 Sha Tin Centre Street, Sha Tin, New Territories', phone: '3997 3566', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-32', name: 'Dr. Chan Yee Yan — Ma On Shan', type: 'ophthalmologist', district: 'Ma On Shan', mtr: 'Ma On Shan', latitude: 22.4248, longitude: 114.2315, address: 'Shop G-3, 52-54 & 69-70, G/F, MOSTown Street, 8 On Shing Street, Ma On Shan, New Territories', phone: '2608 3377', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-33', name: 'Dr. Chan Woon Ming — Yuen Long', type: 'ophthalmologist', district: 'Yuen Long', mtr: 'Yuen Long', latitude: 22.4450, longitude: 114.0260, address: 'Shop 11, G/F, Shun Fat Building, 38-60 Shui Che Kwun Street, Yuen Long, New Territories', phone: '2477 9101', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-34', name: 'Dr. Shum Jennifer Wei Huen', type: 'ophthalmologist', district: 'Yuen Long', mtr: 'Yuen Long', latitude: 22.4460, longitude: 114.0250, address: 'G/F, 2 Kuk Ting Street, Yuen Long, New Territories', phone: '3755 3133', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-35', name: 'Dr. Lam Tsze Ho, Philip', type: 'ophthalmologist', district: 'Kwun Tong', mtr: 'Kwun Tong', latitude: 22.3120, longitude: 114.2230, address: '8 Yan Yip Street, Kwun Tong, Kowloon', phone: '2339 8611', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-36', name: 'Dr. Chan Wai Lok — Kwun Tong', type: 'ophthalmologist', district: 'Kwun Tong', mtr: 'Kwun Tong', latitude: 22.3121, longitude: 114.2257, address: 'Room 1601, 16/F, Crocodile Centre, 79 Hoi Yuen Road, Kwun Tong, Kowloon', phone: '3997 3566', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-37', name: 'Dr. Li Chi Lai', type: 'ophthalmologist', district: 'Tsuen Wan', mtr: 'Tsuen Wan', latitude: 22.3714, longitude: 114.1160, address: 'Room 2006, 20/F, Kolour Tsuen Wan I, 68 Chung On Street, Tsuen Wan, New Territories', phone: '2111 3662', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-38', name: 'Dr. Chan Wai Lok — Tsuen Wan', type: 'ophthalmologist', district: 'Tsuen Wan', mtr: 'Tsuen Wan', latitude: 22.3710, longitude: 114.1120, address: 'G/F, Sze Yuen Mansion, 255 Sha Tsui Road, Tsuen Wan, New Territories', phone: '3997 3566', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-39', name: 'Dr. Leonard Yuen', type: 'ophthalmologist', district: 'Quarry Bay', mtr: 'Tai Koo', latitude: 22.2843, longitude: 114.2165, address: 'Room 1308-1309, 13/F, Kornhill Plaza Office Tower, 1 Kornhill Road, Quarry Bay, Hong Kong', phone: '3101 0001', source: 'hospitalAuthority' },
    { id: 'HK-PUBLIC-40', name: 'Dr. Chan Shun Kit', type: 'ophthalmologist', district: 'Wong Chuk Hang', mtr: 'Wong Chuk Hang', latitude: 22.2490, longitude: 114.1680, address: '1 Nam Fung Path, Wong Chuk Hang, Hong Kong', phone: '3153 9067', source: 'hospitalAuthority' }
  ];

  function previewDemoAllowed(root) {
    return root.dataset.previewDemoEnabled === 'true' &&
      root.dataset.themeRole === 'unpublished';
  }

  function previewProviderLabel(type) {
    if (type === 'ophthalmologist') return 'Ophthalmologist';
    if (type === 'optometrist') return 'Optometrist';
    return 'Eye-care centre';
  }

  function createPreviewDirectoryCard(location, index) {
    var card = document.createElement('article');
    card.className = 'haro-hk-location-card haro-hk-location-card--directory';
    card.dataset.hkLocation = '';
    card.dataset.directory = 'true';
    card.dataset.locationId = location.id;
    card.dataset.name = location.name;
    card.dataset.providerType = location.type;
    card.dataset.address = location.address;
    card.dataset.district = location.district;
    card.dataset.mtr = location.mtr;
    card.dataset.availability = 'unknown';
    card.dataset.confirmedAt = '';
    card.dataset.hours = '{}';
    card.dataset.latitude = String(location.latitude);
    card.dataset.longitude = String(location.longitude);
    card.tabIndex = -1;

    var badge = document.createElement('p');
    badge.className = 'haro-hk-badge haro-hk-badge--directory';
    badge.textContent = 'HONG KONG EYE-CARE DIRECTORY · ' + String(index + 1) + ' OF ' + String(previewDirectoryLocations.length);

    var heading = document.createElement('div');
    heading.className = 'haro-hk-location-card__heading';
    var headingText = document.createElement('div');
    var title = document.createElement('h3');
    title.textContent = location.name;
    var providerType = document.createElement('p');
    providerType.className = 'haro-hk-location-card__type';
    providerType.textContent = previewProviderLabel(location.type) + ' · Public clinic information';
    headingText.appendChild(title);
    headingText.appendChild(providerType);
    heading.appendChild(headingText);

    var address = document.createElement('address');
    var addressLine = document.createElement('p');
    addressLine.textContent = location.address;
    address.appendChild(addressLine);

    var metadata = document.createElement('dl');
    metadata.className = 'haro-hk-location-card__meta';
    [
      ['District', location.district],
      ['Nearby MTR', location.mtr],
      ['Public phone', location.phone]
    ].forEach(function (item) {
      var wrapper = document.createElement('div');
      var term = document.createElement('dt');
      var detail = document.createElement('dd');
      term.textContent = item[0];
      detail.textContent = item[1];
      wrapper.appendChild(term);
      wrapper.appendChild(detail);
      metadata.appendChild(wrapper);
    });

    var note = document.createElement('p');
    note.className = 'haro-hk-location-card__directory-note';
    note.textContent = 'Contact the provider before visiting to confirm Haro Clear availability and appointment requirements.';

    var actions = document.createElement('div');
    actions.className = 'haro-hk-location-card__actions';
    var viewButton = document.createElement('button');
    viewButton.type = 'button';
    viewButton.className = 'btn btn--small btn--outline';
    viewButton.dataset.hkLocationView = '';
    viewButton.textContent = 'Select on map';
    var directionsButton = document.createElement('a');
    directionsButton.className = 'btn btn--small btn--outline';
    directionsButton.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(location.name + ' ' + location.address);
    directionsButton.target = '_blank';
    directionsButton.rel = 'noopener noreferrer';
    directionsButton.dataset.hkDirections = '';
    directionsButton.textContent = 'Open in Google Maps';
    var phoneDigits = String(location.phone || '').replace(/\D/g, '');
    var callButton = document.createElement('a');
    callButton.className = 'btn btn--small btn--solid haro-hk-call-button';
    callButton.href = 'tel:' + (phoneDigits.indexOf('852') === 0 ? '+' : '+852') + phoneDigits;
    callButton.dataset.hkPhone = '';
    callButton.textContent = 'Call';
    var source = previewDirectorySources[location.source];
    var sourceLink = document.createElement('a');
    sourceLink.className = 'haro-hk-text-link haro-hk-location-card__source';
    sourceLink.href = source.url;
    sourceLink.target = '_blank';
    sourceLink.rel = 'noopener noreferrer';
    sourceLink.textContent = 'Verify directory details: ' + source.label;
    actions.appendChild(callButton);
    actions.appendChild(viewButton);
    actions.appendChild(directionsButton);

    card.appendChild(badge);
    card.appendChild(heading);
    card.appendChild(address);
    card.appendChild(metadata);
    card.appendChild(note);
    card.appendChild(actions);
    card.appendChild(sourceLink);
    return card;
  }

  function enablePreviewDoctorDemo(root) {
    if (!previewDemoAllowed(root)) return false;
    var shell = root.querySelector('[data-hk-locator-shell]');
    var results = root.querySelector('[data-hk-results]');
    var insertionPoint = root.querySelector('[data-hk-empty]');
    if (!shell || !results || !insertionPoint) return false;

    Array.prototype.slice.call(
      results.querySelectorAll('[data-location-id^="DEMO-NOT-REAL-"]')
    ).forEach(function (fixture) {
      fixture.remove();
    });

    previewDirectoryLocations.forEach(function (location, index) {
      results.insertBefore(createPreviewDirectoryCard(location, index), insertionPoint);
    });

    var readyState = root.querySelector('[data-hk-empty-ready]');
    var banner = root.querySelector('[data-hk-preview-demo-banner]');
    if (readyState) readyState.hidden = true;
    if (banner) banner.hidden = false;
    shell.hidden = false;
    root.dataset.directoryActive = 'true';
    return true;
  }

  function initLocator(root) {
    enablePreviewDoctorDemo(root);
    var shell = root.querySelector('[data-hk-locator-shell]');
    if (shell && shell.hidden) return;
    var form = root.querySelector('[data-hk-locator-form]');
    var search = root.querySelector('[data-hk-search]');
    var provider = root.querySelector('[data-hk-provider]');
    var openNow = root.querySelector('[data-hk-open-now]');
    var recent = root.querySelector('[data-hk-recent]');
    var status = root.querySelector('[data-hk-status]');
    var noResults = root.querySelector('[data-hk-no-results]');
    var empty = root.querySelector('[data-hk-empty]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hk-location]'));
    var userPosition = null;

    if (!form) return;

    function visibleCards() {
      return cards.filter(function (card) { return !card.hidden; });
    }

    function formatDistance(distance) {
      if (!Number.isFinite(distance)) return '';
      if (distance < 1) return Math.max(50, Math.round(distance * 1000 / 50) * 50) + ' m away';
      return distance.toFixed(distance < 10 ? 1 : 0) + ' km away';
    }

    function showDistances(position) {
      cards.forEach(function (card) {
        var distance = locationDistance(card, position);
        var label = card.querySelector('[data-hk-distance]');
        if (!Number.isFinite(distance)) {
          if (label) label.remove();
          return;
        }
        if (!label) {
          label = document.createElement('span');
          label.className = 'haro-hk-location-card__distance';
          label.dataset.hkDistance = '';
          var heading = card.querySelector('.haro-hk-location-card__heading');
          if (heading) heading.appendChild(label);
        }
        label.textContent = formatDistance(distance);
      });
    }

    function announce(count) {
      if (!status) return;
      status.textContent = String(root.dataset.messageResults || '').replace('__COUNT__', count);
    }

    function applyFilters(emitAnalytics) {
      var query = safeText(search && search.value);
      var providerValue = safeText(provider && provider.value);
      var count = 0;

      cards.forEach(function (card) {
        var searchable = [
          card.dataset.name,
          card.dataset.address,
          card.dataset.district,
          card.dataset.mtr
        ].map(safeText).join(' ');
        var matches = (!query || searchable.indexOf(query) !== -1) &&
          (!providerValue || safeText(card.dataset.providerType) === providerValue) &&
          (!openNow || !openNow.checked || isOpenNow(card)) &&
          (!recent || !recent.checked || confirmedRecently(card));
        card.hidden = !matches;
        if (matches) count += 1;
      });

      if (empty) empty.hidden = cards.length > 0;
      if (noResults) noResults.hidden = count > 0 || cards.length === 0;
      announce(count);

      root.dispatchEvent(new CustomEvent('haro:hk:locations-filtered', {
        bubbles: true,
        detail: { cards: visibleCards() }
      }));

      if (emitAnalytics) {
        track('hk_locator_search', {
          provider_type: providerValue,
          result_count: count,
          language: document.documentElement.lang || 'en'
        });
        if (count === 0 && cards.length > 0) {
          track('hk_locator_no_results', {
            provider_type: providerValue,
            result_count: 0,
            language: document.documentElement.lang || 'en'
          });
        }
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilters(true);
    });
    form.addEventListener('reset', function () {
      window.setTimeout(function () { applyFilters(false); }, 0);
    });
    [provider, openNow, recent].filter(Boolean).forEach(function (control) {
      control.addEventListener('change', function () { applyFilters(true); });
    });

    var broaden = root.querySelector('[data-hk-broaden]');
    if (broaden) {
      broaden.addEventListener('click', function () {
        form.reset();
        search.focus();
      });
    }

    var useLocation = root.querySelector('[data-hk-use-location]');
    if (useLocation) {
      useLocation.addEventListener('click', function () {
        if (!navigator.geolocation) {
          status.textContent = root.dataset.messageLocationUnsupported || '';
          return;
        }
        status.textContent = root.dataset.messageLocationRequesting || '';
        navigator.geolocation.getCurrentPosition(function (position) {
          userPosition = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
          showDistances(userPosition);
          cards.sort(function (left, right) {
            return compareLocationDistance(left, right, userPosition);
          }).forEach(function (card) {
            card.parentNode.insertBefore(card, noResults || empty);
          });
          var resultsPanel = root.querySelector('[data-hk-results]');
          if (resultsPanel) resultsPanel.scrollTop = 0;
          status.textContent = root.dataset.messageLocationSorted || '';
        }, function () {
          status.textContent = root.dataset.messageLocationUnavailable || '';
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
      });
    }

    cards.forEach(function (card) {
      var properties = {
        location_id: card.dataset.locationId,
        provider_type: card.dataset.providerType,
        district: card.dataset.district
      };
      var view = card.querySelector('[data-hk-location-view]');
      if (view) view.addEventListener('click', function () {
        cards.forEach(function (item) { item.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        card.focus();
        root.dispatchEvent(new CustomEvent('haro:hk:location-selected', {
          bubbles: true,
          detail: { card: card }
        }));
        track('hk_location_view', properties);
      });
      var directions = card.querySelector('[data-hk-directions]');
      if (directions) directions.addEventListener('click', function () { track('hk_directions_click', properties); });
      var phone = card.querySelector('[data-hk-phone]');
      if (phone) phone.addEventListener('click', function () { track('hk_phone_click', properties); });
      var website = card.querySelector('[data-hk-location-website]');
      if (website) website.addEventListener('click', function () { track('hk_location_website_click', properties); });
    });

    var viewButtons = Array.prototype.slice.call(root.querySelectorAll('[data-hk-view]'));
    var mapPanel = root.querySelector('[data-hk-map-panel]');
    var results = root.querySelector('[data-hk-results]');
    var mapLoaded = false;

    function loadMap() {
      if (mapLoaded) return;
      mapLoaded = true;
      var script = document.createElement('script');
      script.src = root.dataset.mapScript;
      script.defer = true;
      script.addEventListener('load', function () {
        if (window.HaroHKMap) window.HaroHKMap.init(root, visibleCards());
      });
      document.head.appendChild(script);
    }

    function setView(view) {
      var showMap = view === 'map';
      mapPanel.hidden = !showMap;
      results.hidden = showMap && window.matchMedia('(max-width: 989px)').matches;
      viewButtons.forEach(function (button) {
        var active = button.dataset.hkView === view;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.classList.toggle('btn--solid', active);
        button.classList.toggle('btn--outline', !active);
      });
      if (showMap) loadMap();
    }

    viewButtons.forEach(function (button) {
      button.addEventListener('click', function () { setView(button.dataset.hkView); });
    });
    var loadMapButton = root.querySelector('[data-hk-load-map]');
    if (loadMapButton) loadMapButton.addEventListener('click', loadMap);

    applyFilters(false);
    setView(window.matchMedia('(max-width: 989px)').matches ? 'list' : 'map');
  }

  function bindAnalytics() {
    document.querySelectorAll('[data-hk-infinity]').forEach(function (element) {
      element.addEventListener('click', function () { track('hk_infinity_contact_click'); });
    });

    var research = document.querySelector('[data-hk-research]');
    if (research && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        track('hk_research_view', { language: document.documentElement.lang || 'en' });
        observer.disconnect();
      }, { threshold: 0.35 });
      observer.observe(research);
    }
  }

  function boot() {
    document.querySelectorAll('[data-hk-locator]').forEach(initLocator);
    bindAnalytics();
  }

  window.HaroHKHours = Object.freeze({
    isOpenAt: isOpenAt,
    parseHours: parseHours,
    timeZone: 'Asia/Hong_Kong'
  });
  window.HaroHKLocations = Object.freeze({
    compareDistance: compareLocationDistance,
    distanceForCard: locationDistance,
    parseCoordinate: parseCoordinate
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
